import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { getMessage } from '@gef-ui/localization/messages';

import Dialog from 'app/components/MaterialDialog';
import Version from 'components/atoms/Version';
import PAGES from 'constants/pages';

import SemaphoreFeedbackDetailModalBody from './SemaphoreFeedbackDetailModalBody';

const SemaphoreFeedbackDetailModal = NiceModal.create(({ record }) => {
	const modal = useModal();

	return (
		<Dialog
			modal={modal}
			title={getMessage('semaphore:feedbackDetailModalTitle')}
			content={<SemaphoreFeedbackDetailModalBody record={record} />}
			maxWidth="lg"
			version={
				<Version
					screenId={PAGES.semaphore.semaphoreFeedbackDetailModal.id}
					screenName={PAGES.semaphore.semaphoreFeedbackDetailModal.name}
				/>
			}
		/>
	);
});

export default SemaphoreFeedbackDetailModal;
